const listeners = new Set();

export function onToast(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}

function emit(toast) {
    listeners.forEach((fn) => {
        try {
            fn(toast);
        } catch (e) {
            // ignore
        }
    });
}

export function success(message, opts = {}) {
    emit({ type: 'success', message, ...opts });
}

export function error(message, opts = {}) {
    emit({ type: 'error', message, ...opts });
}

export function info(message, opts = {}) {
    emit({ type: 'info', message, ...opts });
}

export default {
    onToast,
    success,
    error,
    info,
};
